<template>
  <div class="ap-order-logistic">
    <table v-if="logistics.length" class="table table-hover out">
      <thead class="thead-light border-top">
        <tr>
          <th class="text-center">物流单号</th>
          <th class="text-center">签收状态</th>
          <th class="text-center">收货人</th>
          <th class="text-center">发货日期</th>
          <th class="text-center">发货方式</th>
          <th class="text-center">物流公司</th>
          <th class="text-center">商品件数</th>
          <th class="text-center">签收日期</th>
        </tr>
      </thead>
      <tbody v-for="(it,index) in logistics" :key="index">
        <tr @click="it.show = !it.show" style="cursor: pointer;">
          <td style="width:200px;">
            <div class="tile tile-circle" style="margin-right:20px;">
              <span class="fas fa-angle-right" v-if="!it.show"></span>
              <span class="fas fa-angle-down" v-if="it.show"></span>
            </div>
            {{it.trackingNumber}}
          </td>
          <td class="text-center">{{it.shippingStatus=="SHIPPED"?'已签收':'未签收'}}</td>
          <td class="text-center">{{it.buyerOrgName}}</td>
          <td class="text-center">{{it.deliveryTime | toShortDate}}</td>
          <td class="text-center">公路物流</td>
          <td class="text-center">{{it.org}}</td>
          <td class="text-center">{{it.totalQty}}</td>
          <td class="text-center" @click.stop="0">
            <span
              v-if="it.shippingStatus=='SHIPPED'"
              @click.stop="view(it)"
              class="sign-time"
            >{{it.shippedTime | toShortDate}}</span>
            <button v-else @click.stop="sign(it.logisticsId)" class="btn btn-secondary btn-sm">确认签收</button>
          </td>
        </tr>
        <tr v-if="it.show">
          <td colspan="8" style="padding:20px;background:#F6F7F9">
            <ul>
              <li style="padding:5px;">{{it.deliveryTime|toShortDate}} 您的订单已经发货</li>
              <li style="padding:10px;text-decoration:underline;color:#f03;cursor:pointer;">查看全部物流状态</li>
            </ul>
            <table class="table table-bordered table-hover inner">
              <thead class="thead-light">
                <tr>
                  <th class="text-center">商品代码</th>
                  <th class="text-center" style="width:300px;">商品名称</th>
                  <th class="text-center">交付包装类型</th>
                  <th class="text-center">包装数</th>
                  <th class="text-center">包装内摆放/件数</th>
                  <th class="text-center">发货件数</th>
                  <th class="text-center">单价(元)</th>
                  <th class="text-center">金额(元)</th>
                </tr>
              </thead>
              <tbody style="background:#fff">
                <tr v-for="(item,index) in it.logisticsItems" :key="index">
                  <td style="text-center;">{{item.productNumber}}</td>
                  <td class="text-center">{{item.commodityName}}</td>
                  <td class="text-center">{{item.pkgContainerLiteral}}</td>
                  <td class="text-center">{{item.packageQty}}</td>
                  <td
                    class="text-center"
                  >{{item.pkgLayHigQty}}x{{item.pkgLayLenQty}}x{{item.pkgLayWidQty}}/{{item.pkgLayQty}}件</td>
                  <td class="text-center">{{item.qty}}</td>
                  <td class="text-center">{{item.unitPrice | toMoney}}</td>
                  <td class="text-center">{{item.amount | toMoney}}</td>
                </tr>
                <tr>
                  <td class="text-right" colspan="5">合计：</td>
                  <td class="text-center">{{ it | addCount }}</td>
                  <td></td>
                  <td class="text-center">{{ it | addMoney | toMoney }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="text-center" style="padding:35px;">暂无发货记录！</div>

    <Signature
      v-if="showSignDialog"
      :picId="signaturePicId"
      :signTime="shippedTime"
      @affirm="affirm"
      @close="showSignDialog=false"
    ></Signature>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Signature from "@components/Signature.vue";

export default {
  props: ["logistics"],
  components: {
    Pagination,
    Signature
  },
  data() {
    return {
      showSignDialog: false,
      signId: "",
      shippedTime: 0, // 查看签收的时间
      signaturePicId: "" // 查看签收的图片
    };
  },
  methods: {
    sign(id) {
      this.signaturePicId = "";
      this.showSignDialog = true;
      this.signId = id;
    },
    view(it) {
      this.shippedTime = it.shippedTime;
      this.signaturePicId = this.getOpenFileUrl(it.signaturePicId);
      this.showSignDialog = true;
    },
    affirm(blob) {
      let formData = new FormData();
      formData.append("file", blob, `签名于-${Date.now()}.jpg`);
      this.$http({
        url: "/shared/storage/parts360-open/upload",
        data: formData,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(res => {
          return this.$post("/opms/logistics/signed", {
            id: this.signId,
            signaturePicId: res.data.uri
          });
        })
        .then(() => {
          this.showSignDialog = false;
        })
        .catch(err => {
          $msg.error("签收失败");
        });
    }
  },
  filters: {
    addCount(list) {
      let temp = 0;
      list.logisticsItems.forEach(it => {
        temp += it.qty;
      });
      return temp;
    },
    addMoney(list) {
      let temp = 0;
      list.logisticsItems.forEach(it => {
        temp += it.amount;
      });
      return temp;
    }
  }
};
</script>

<style lang="less">
.ap-order-logistic {
  .table {
    margin: 0;
    thead {
      background: #f6f7f9;
    }
    td {
      vertical-align: middle;
      .sign-time {
        color: #ff2b2b;
        text-decoration: underline;
      }
    }
  }
  .title {
    margin-bottom: 20px;
    font-size: 24px;
  }
  .order-number {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 3px solid #f2f2f2;
    label,
    a {
      display: inline-block;
    }
    label {
      margin-bottom: 0;
      margin-right: 30px;
      color: #999;
    }
  }
  .ap-pnl {
    margin-top: 15px;
  }
  .info {
    > div {
      float: left;
      width: 15%;

      &:last-child {
        width: 40%;
      }
    }
    label {
      display: block;
      margin-bottom: 0;
      color: #999;
    }
    span {
      color: #f03;
    }
  }
  .summary {
    text-align: right;
    color: #666;
    label,
    span {
      display: inline-block;
      vertical-align: top;
    }
    span {
      padding-right: 0.75rem;
      width: 140px;
      text-align: right;
    }
  }
}
</style>